'use client'

import { useState, useEffect, useRef } from 'react'
import { useForm, ValidationError } from '@formspree/react'

export default function Newsletter() {
  const [state, handleSubmit] = useForm('mvgezvqg')
  const [notification, setNotification] = useState<{ message: string; type: 'success' | 'error' | 'info' } | null>(null)
  const formRef = useRef<HTMLFormElement>(null)

  const showNotification = (message: string, type: 'success' | 'error' | 'info' = 'info') => {
    setNotification({ message, type })
    setTimeout(() => setNotification(null), 5000)
  }

  useEffect(() => {
    if (state.succeeded) {
      showNotification('Successfully subscribed! Thank you for joining.', 'success')
      // Clear the form
      if (formRef.current) {
        formRef.current.reset()
      }
    }
    if (state.errors) {
      showNotification('There was an error subscribing. Please try again.', 'error')
    }
  }, [state.succeeded, state.errors])

  return (
    <section className="newsletter-section">
      <div className="container">
        <div className="newsletter-layout">
          <h2 className="newsletter-title font-logo">Get Automation Ideas You Can Use This Week</h2>
          <form ref={formRef} className="newsletter-form" onSubmit={handleSubmit}>
            <div className="newsletter-flex-container">
              <input type="email" id="email" name="email" className="newsletter-input" placeholder="Enter your email" required />
              <ValidationError prefix="Email" field="email" errors={state.errors} />
            </div>
            <button type="submit" className="newsletter-submit-btn font-logo" disabled={state.submitting}>
              {state.submitting ? 'Subscribing...' : 'Send Me Free Ideas'}
            </button>
          </form>
        </div>
        {notification && (
          <>
            {/* Backdrop */}
            <div className="newsletter-modal-backdrop" onClick={() => setNotification(null)} />
            {/* Modal */}
            <div className={`newsletter-modal ${notification.type}`}>
              <div className="newsletter-modal-content">
                <div className="newsletter-modal-message">{notification.message}</div>
                <button onClick={() => setNotification(null)} className="newsletter-modal-close" aria-label="Close notification">
                  ×
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  )
}
